import { Box } from '@chakra-ui/react';
import React from 'react';
import PanelContainerWithFallback from '../../FindingPanel/PanelContainerWithFallback';
import { useTokens } from '../../../../context/TokenProvider';
const ScrollablePanel = ({ children, variant = 'remote-submission', ...rest }) => {
    const tokens = useTokens();
    const variantProps = {
        'remote-submission': {
            maxH: '106px',
            minH: '106px',
            minW: '220px',
            bg: tokens.Layer04,
        },
        'officer-assessment': {
            bg: tokens.CanvasPrimary200,
        },
    };
    return (React.createElement(Box, { py: tokens.Spacing03, px: tokens.Spacing05, flex: "1", borderRadius: tokens.BorderRadius02, overflowY: "auto", "data-testid": "scrollable_panel", ...variantProps[variant] },
        React.createElement(PanelContainerWithFallback, { alignItems: "flex-start", whiteSpace: "pre-wrap", wordBreak: "break-word", ...rest }, children)));
};
export default ScrollablePanel;
